// extracted by mini-css-extract-plugin
export default {"pt80":"MainLayout_pt80__6EsNj"};